export default "__VITE_ASSET__DKnlyHZV__"